const GET_AGREEMENT = 'agreement/GET_AGREEMENT'

export const getAgreement = page => ({
  type: GET_AGREEMENT,
  page
})

const initialAgreement = [
  {
    id: 1,
    name: "Ali",
    company: "kerry",
    email: "test@test.com",
    tel: "010-0000-0000",
    inquiry:
      "안녕하세요 000 입니다. 유스비 서비스의 세부 가격 정보가 궁금합니다. 안녕하세요 000 입니다. 유스비 서비스의 세부 가격 정보가 궁금합니다. 안녕하세요 000 입니다. 유스비 서비스의 세부 가격 정보가 궁금합니다."
  },
  {
    id: 2,
    name: "Bbb",
    company: "terra",
    email: "test@test.com",
    tel: "010-0000-0000",
    inquiry:
      "안녕하세요 000 입니다. 유스비 서비스의 세부 가격 정보가 궁금합니다."
  },
  {
    id: 3,
    name: "Carrot",
    company: "Poly",
    email: "test@test.com",
    tel: "010-0000-0000",
    inquiry:
      "안녕하세요 000 입니다. 유스비 서비스의 세부 가격 정보가 궁금합니다."
  },
  {
    id: 4,
    name: "Dude",
    company: "Nolo",
    email: "test@test.com",
    tel: "010-0000-0000",
    inquiry:
      "안녕하세요 000 입니다. 유스비 서비스의 세부 가격 정보가 궁금합니다."
  },
  {
    id: 5,
    name: "Evan",
    company: "Chris",
    email: "test@test.com",
    tel: "010-0000-0000",
    inquiry:
      "안녕하세요 000 입니다. 유스비 서비스의 세부 가격 정보가 궁금합니다."
  }
]

export default function agreementReducer(state= initialAgreement, action){
  switch(action.type){
    case GET_AGREEMENT:
      return state;
    default :
      return state;
  }
}